module.exports = __webpack_public_path__ + "static/media/about-icon-design.e1dc427f.svg";